"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentRegistrations = void 0;
const sdk_1 = require("../sdk");
var StudentRegistrations;
(function (StudentRegistrations) {
    StudentRegistrations.list = (options) => {
        const url = '/student-registrations';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    StudentRegistrations.get = (studentRegistrationId) => {
        const url = `/student-registrations/${studentRegistrationId}`;
        return sdk_1.SDK.axios.get(url);
    };
})(StudentRegistrations = exports.StudentRegistrations || (exports.StudentRegistrations = {}));
//# sourceMappingURL=student-registrations.js.map